import { useLang } from "../i18n/LanguageContext";

function FlagTR({ className }) {
  return (
    <svg viewBox="0 0 1200 800" className={className} aria-hidden="true">
      <rect width="1200" height="800" fill="#E30A17" />
      <circle cx="425" cy="400" r="200" fill="#fff" />
      <circle cx="475" cy="400" r="160" fill="#E30A17" />
      <polygon
        fill="#fff"
        points="740,305 761.3,370.6 830.4,370.6 774.5,411.2 795.8,476.9 740,436.3 684.2,476.9 705.5,411.2 649.6,370.6 718.7,370.6"
      />
    </svg>
  );
}

function FlagEN({ className }) {
  return (
    <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
      <clipPath id="ls-uk-t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <rect width="60" height="30" fill="#00247D" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#ls-uk-t)" stroke="#CF142B" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#CF142B" strokeWidth="6" />
    </svg>
  );
}

const OPTIONS = [
  { code: "tr", label: "TR", full: "Türkçe", Flag: FlagTR },
  { code: "en", label: "EN", full: "English", Flag: FlagEN },
];

export default function LanguageSwitcher({ size = "sm", variant = "desktop" }) {
  const { lang, setLang } = useLang();
  const pad = size === "lg" ? "px-3 py-2 text-sm" : "px-1.5 py-1 text-[11px]";

  return (
    <div
      data-testid={`language-switcher-${variant}`}
      className="inline-flex items-center gap-1 rounded-xl border border-white/15 bg-white/[0.04] p-1"
    >
      {OPTIONS.map(({ code, label, full, Flag }) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-label={full}
            title={full}
            aria-pressed={active}
            data-testid={`lang-btn-${code}-${variant}`}
            className={`inline-flex items-center gap-1.5 rounded-lg font-semibold transition-all ${pad} ${
              active
                ? "bg-gradient-to-r from-[#F97316] to-[#FB923C] text-white shadow-md shadow-[#F97316]/25"
                : "text-white/55 hover:text-white hover:bg-white/[0.06]"
            }`}
          >
            <Flag className={`${size === "lg" ? "h-4 w-6" : "h-3 w-[18px]"} rounded-[2px] object-cover ${active ? "" : "opacity-70"}`} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
